import React from 'react';
import { ValidatedControl } from '../Components/ValidatedControl';
import { Field } from 'react-final-form';
import { FolderDropdown } from './FolderDropdown/FolderDropdown';
import { ITreeData } from './Tree/types';
import { IBaseControlField } from './types';
import { IFolderDropdownData } from './FolderDropdown/types';

export interface IFolderDropdownField extends IBaseControlField {
    nodes: IFolderDropdownData[];
    allowSearch?: boolean;
}

export const FolderDropdownField = ({ label, name, disabled, ...rest }: IFolderDropdownField) => (
    <Field<ITreeData> name={name}>
        {({ input, meta }) => {
            const invalid = (meta.error || meta.submitError) && meta.touched;
            return (
                <ValidatedControl
                    id={name}
                    disabled={disabled}
                    invalid={invalid}
                    caption={label}
                    validationMessage={meta.error}
                    variant="SmallColumns"
                >
                    {(props) => <FolderDropdown {...props} {...input} {...rest} invalid={invalid}/>}
                </ValidatedControl>
            );
        }}
    </Field>
);
